import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  Tab,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Tabs,
  TextField,
} from "@mui/material";
import {
  ButtonContain,
  Card,
  CardContain,
  FieldContain,
  TabsContain,
} from "../../style/Home";
import Grid from "@mui/material/Grid";
import Filter from "../../Components/filters";
// import Table from '../../Components/table/Table';
import ExcelIcon from "../../assets/images/icons/excel.png";
import {
  CommanTableContain,
  ContainerCustom,
  PaginationContain,
  SmartSearchContain,
} from "../../style/table";
import SearchIcon from "@mui/icons-material/Search";
import { Link } from "react-router-dom";
import { GetMvrMoM, GetBmvrMoM } from "../../services/mvrMomServices";
import { resetFilter } from "../../features/filterSlice";

const MoMStatus = () => {
  const location = useLocation();
  const [value, setValue] = useState(location?.state?.currentSwitchedTab || "momstatus");
  const [isSticky, setIsSticky] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const [tableData, setTableData] = useState([]);
  const [bMvrMoMData, setBmvrMoMData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [filterValues, setFilterValues] = useState({});
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [isDispatched, setIsDispatched] = useState(false);
  const [resetTrigger, setResetTrigger] = useState(false);

  const filtersValue = useSelector((state) => state.filterData);
  // const navigate = useNavigate();

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setSearch("");
    setPage(0);
    setRowsPerPage(10);
    setDebouncedSearchTerm("");
    dispatch(resetFilter());
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(event.target.value);
  };

  useEffect(()=>{
    dispatch(resetFilter());
    setIsDispatched(true)
  }, [dispatch])

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // fetch mom status data
  const fetchData = async () => {
    try {
      let payload = filtersValue;
      payload = {...payload, 
        search: debouncedSearchTerm, 
        page: page, 
        offset: rowsPerPage
      } 

      const response = await GetMvrMoM({ payload: payload });
      if (response && response.momData) {
        setTableData(response.momData);
        setTotalCount(response.totalCount);
      } else {
        console.error("Failed to fetch data.");
      }
    } catch (error) {
      console.error("Error fetching MoM data:", error);
    }
  };

  const getBmvrMoMData = async () => {
    try{
      let payload = filtersValue;
      payload = {...payload,
        search: debouncedSearchTerm,
        page: page,
        offset: rowsPerPage,
      }

      const response = await GetBmvrMoM({payload: payload});
      if (response && response.data.bmvrMomData){
        setBmvrMoMData(response.data.bmvrMomData);
        setTotalCount(response.data.totalCount);
      }else {
        console.log('Error on loading MoM data: ', error);
      }
    }catch(error){
      console.log('Error on loading data: ', error)
    }
  }

  useEffect(() => {
    if (isDispatched && value === "momstatus"){
      fetchData();
    }
    if (isDispatched && value === "BMVRTabs"){
      getBmvrMoMData();
    }
  }, [page, rowsPerPage, debouncedSearchTerm, resetTrigger, isDispatched, value]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchTerm(search);
    }, 600)
    return () => clearTimeout(handler);
  }, [search]);

  const handleFilterChange = (filterKey, value) => {
    setFilterValues((prev) => ({
      ...prev,
      [filterKey]: value,
    }));
  };

  const handleSearch = async () => {
    if (value === "momstatus"){
      await fetchData();
    }else {
      await getBmvrMoMData();
    }
  }

  const handleReset = () => {
    dispatch(resetFilter())
    setResetTrigger(Date.now())
    setTimeout(() => setResetTrigger(false), 0)
  }

  return (
    <>
      <TabsContain className="TabsContain">
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="tabs example"
          className={`HomeTabs ${isSticky ? "StickyShadow" : ""}`}
        >
          <Tab label="MoM Status" value="momstatus" />
          <Tab label="BMVR MoM Status" value="BMVRTabs" />
        </Tabs>
      </TabsContain>
      {value === "momstatus" && (
        <>
          <CardContain>
            <Card mt={1} className="Filter_bg">
              <Grid container spacing={1}>
                <Filter
                  // filters={filtersData}
                  onFilterChange={handleFilterChange}
                  reset={resetTrigger}
                ></Filter>
                <Grid item xs={12} sm={12} lg={12}>
                  <ButtonContain
                    sx={{ height: "100%", alignItems: "end", gap: "5px" }}
                  >
                    <button
                      className="SearchButton"
                      onClick={handleSearch}
                    >
                      Search
                    </button>
                    <button className="ResetButton" onClick={handleReset}>Reset</button>
                    {/* <button className="ExportButton">
                      <img src={ExcelIcon} alt="Excel icon" />
                    </button> */}
                  </ButtonContain>
                </Grid>
              </Grid>
            </Card>
          </CardContain>
          <CardContain>
            <Card mt={2}>
            <ContainerCustom>
                <SmartSearchContain>
                  <TextField
                    label="Search"
                    variant="outlined"
                    size="small"
                    fullWidth
                    marginleft="auto"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                  <SearchIcon />
                </SmartSearchContain>
              </ContainerCustom>
              <CommanTableContain>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{position: 'sticky',left: 0,top: 0,zIndex: 9,}}>Dealer Code</TableCell>
                      <TableCell>Dealership Name</TableCell>
                      <TableCell>City</TableCell>
                      <TableCell>Total MoM Points</TableCell>
                      <TableCell>Open MoM Points</TableCell>
                      <TableCell>MoM Points Completed By Dealers</TableCell>
                      <TableCell>MoM Points Closed By AM</TableCell>
                      <TableCell>Escalated To AM</TableCell>
                      <TableCell>Escalated To ZM</TableCell>
                      <TableCell>Escalated To RM</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {tableData.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell sx={{position: 'sticky',left: 0,zIndex: 8,}}>
                          <Link to="/momstatusupdate" state={{ row }}>
                            {row.dealerCode}
                          </Link>
                        </TableCell>
                        <TableCell>{row.dealerName}</TableCell>
                        <TableCell>{row.city || ""}</TableCell>{" "}
                        {/* If city is null, show 'N/A' */}
                        <TableCell>{row.totalMom}</TableCell>
                        <TableCell>{row.openMom + row.reopenedMom}</TableCell>
                        <TableCell>{row.completedMom}</TableCell>
                        <TableCell>{row.closedMom}</TableCell>
                        <TableCell>{row.amEsc}</TableCell>
                        <TableCell>{row.zmEsc}</TableCell>
                        <TableCell>{row.rmEsc}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </CommanTableContain>

              {/* Pagination */}
              <PaginationContain>
                <TablePagination
                  component="div"
                  count={totalCount} // Total number of items from API
                  page={page}
                  rowsPerPage={rowsPerPage}
                  onPageChange={handlePageChange}
                  onRowsPerPageChange={handleRowsPerPageChange} // Option to handle rows per page change
                />
              </PaginationContain>
            </Card>
          </CardContain>
        </>
      )}
      {value === "BMVRTabs" && (
        <>
          <CardContain>
            <Card mt={1} className="Filter_bg">
              <Grid container spacing={1}>
                <Filter
                  reset={resetTrigger}
                  onFilterChange={handleFilterChange}
                  showBmvrFrequency={true}
                ></Filter>
                <Grid item xs={12}>
                  <ButtonContain>
                    <button className="SearchButton" onClick={handleSearch}>Search</button>
                    <button className="ResetButton" onClick={handleReset}>Reset</button>
                    {/* <button className="ExportButton">Export</button> */}
                  </ButtonContain>
                </Grid>
              </Grid>
            </Card>
          </CardContain>
          <CardContain>
            <Card mt={2}>
            <ContainerCustom>
                <SmartSearchContain>
                  <TextField
                    label="Search"
                    variant="outlined"
                    size="small"
                    fullWidth
                    marginleft="auto"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                  <SearchIcon />
                </SmartSearchContain>
              </ContainerCustom>
              <CommanTableContain>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{position: 'sticky',left: 0,top: 0,zIndex: 9,}}>Dealer Code</TableCell>
                      <TableCell>Dealership Name</TableCell>
                      <TableCell>City</TableCell>
                      <TableCell>Total MoM Points</TableCell>
                      <TableCell>Open MoM Points</TableCell>
                      <TableCell>MoM Points Completed By Dealers</TableCell>
                      <TableCell>MoM Points Closed By AM</TableCell>
                      <TableCell>Escalated To AM</TableCell>
                      <TableCell>Escalated To ZM</TableCell>
                      <TableCell>Escalated To RM</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {bMvrMoMData.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell sx={{position: 'sticky',left: 0,zIndex: 8,}}>
                          <Link to="/bmvr-momstatusupdate" state={{ row }}>
                            {row.dealerCode}
                          </Link>
                        </TableCell>
                        <TableCell>{row.dealerName}</TableCell>
                        <TableCell>{row.city || ""}</TableCell>{" "}
                        {/* If city is null, show 'N/A' */}
                        <TableCell>{row.totalMom}</TableCell>
                        <TableCell>{row.openMom + row.reopenedMom}</TableCell>
                        <TableCell>{row.completedMom}</TableCell>
                        <TableCell>{row.closedMom}</TableCell>
                        <TableCell>{row.amEsc}</TableCell>
                        <TableCell>{row.zmEsc}</TableCell>
                        <TableCell>{row.rmEsc}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </CommanTableContain>

              {/* Pagination */}
              <PaginationContain>
                <TablePagination
                  component="div"
                  count={totalCount} // Total number of items from API
                  page={page}
                  rowsPerPage={rowsPerPage}
                  onPageChange={handlePageChange}
                  onRowsPerPageChange={handleRowsPerPageChange} // Option to handle rows per page change
                />
              </PaginationContain>
            </Card>
          </CardContain>
        </>
      )}
    </>
  );
};

export default MoMStatus;
